<template>
  <el-form-item :label="label" :prop="field">
    <el-select :disabled="isDisabled"
      v-bind:value="value"
      v-on:input="check"
      :loading="isLoading">
      <el-option v-for="(option) in options" :key="option.value"
        :label="option.label"
        :value="option.value">
      </el-option>
    </el-select>
  </el-form-item>
</template>

<script>
export default {
  name: 'Select_Component',
  props: {
    value: [String, Date, Number],
    label: {
      type: String,
      default: ''
    },
    field: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      defaut: 'text'
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    check (e) {
      this.$emit('input', e)
    },
    handleInput (val) {
      this.$emit('handleInput',
        {
          label: this.$props.field,
          value: val
        }
      )
    },
    setValue (val) {
      this.$data.value = val
    }
  },
  // watch: {
  //   value (val) {
  //     if (val) {
  //       this.handleInput(val)
  //     }
  //   }
  // }
}
</script>

<style lang="scss" scoped>
</style>
